(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-cards"] && !Shopify.designMode) return;
  try {
    
  function alignPressAnchor() {
    if (window.location.hash !== '#in-the-press') return;
    requestAnimationFrame(() => {
      document.getElementById('in-the-press')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    });
  }
  window.addEventListener('pageshow', alignPressAnchor);
  if (document.readyState === 'complete') alignPressAnchor();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-cart-form]');
      if (!form) return;
      const status = root.querySelector('[data-cart-status]');
      let busy = false;
      async function request(endpoint, payload) {
        const response = await fetch(`${root.dataset.root}cart/${endpoint}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || status.dataset.error);
        return data;
      }
      async function run(action) {
        if (busy) return;
        busy = true;
        status.textContent = status.dataset.working;
        const controls = [...root.querySelectorAll('button,input,select')];
        controls.forEach((el) => (el.disabled = true));
        try {
          await action();
        } catch (error) {
          status.textContent = error.message || status.dataset.error;
          busy = false;
          controls.forEach((el) => (el.disabled = false));
          if (root.dataset.addonUncertain)
            root.querySelectorAll('[data-cart-addon-form] button').forEach((el) => (el.disabled = true));
        }
      }
      root.querySelectorAll('[data-cart-addon-form]').forEach((addonForm) => {
        const card = addonForm.closest('[data-cart-addon]');
        const select = addonForm.querySelector('[data-addon-select]');
        if (select) {
          select.value = select.dataset.preferred;
          select.addEventListener('change', () => {
            const option = select.selectedOptions[0];
            card.querySelector('[data-addon-price]').textContent = option.dataset.price;
            const compare = card.querySelector('[data-addon-compare]');
            if (compare) {
              compare.textContent = option.dataset.compare || '';
              compare.hidden = !option.dataset.compare;
            }
            card.querySelectorAll('[data-addon-link]').forEach((link) => {
              const url = new URL(link.href);
              url.searchParams.set('variant', select.value);
              link.href = url.href;
            });
            const image = card.querySelector('[data-addon-image]');
            if (image && option.dataset.image) {
              image.removeAttribute('srcset');
              image.src = option.dataset.image;
            }
          });
        }
        addonForm.addEventListener('submit', (event) => {
          event.preventDefault();
          if (busy || root.dataset.addonUncertain) return;
          const variantId = addonForm.querySelector('[name="id"]').value;
          run(async () => {
            const readCart = async () => {
              const response = await fetch(`${root.dataset.root}cart.js`, {
                headers: { Accept: 'application/json' },
                cache: 'no-store',
              });
              if (!response.ok) throw new Error(status.dataset.error);
              return response.json();
            };
            const before = await readCart();
            if (before.items.some((item) => String(item.product_id) === card.dataset.productId)) {
              location.reload();
              return;
            }
            try {
              await request('add', { items: [{ id: variantId, quantity: 1 }] });
            } catch (error) {
              try {
                const after = await readCart();
                if (after.items.some((item) => String(item.variant_id) === variantId)) {
                  location.reload();
                  return;
                }
              } catch {
                root.dataset.addonUncertain = 'true';
                throw new Error(root.dataset.addonRefresh);
              }
              throw error;
            }
            location.reload();
          });
        });
      });
      root.querySelectorAll('[data-quantity-step]').forEach((button) =>
        button.addEventListener('click', () => {
          const input = button.parentElement.querySelector('input');
          const quantity = Math.max(
            0,
            Number(input.value) + Number(button.dataset.quantityStep) * Number(input.step || 1),
          );
          run(async () => {
            await request('change', { line: Number(input.dataset.line), quantity });
            location.reload();
          });
        }),
      );
      root.querySelectorAll('[data-cart-remove]').forEach((link) =>
        link.addEventListener('click', (event) => {
          event.preventDefault();
          run(async () => {
            await request('change', { line: Number(link.dataset.line), quantity: 0 });
            location.reload();
          });
        }),
      );
      form.querySelectorAll('input[name="updates[]"]').forEach((input) =>
        input.addEventListener('change', () => {
          if (input.value === input.dataset.original || !input.reportValidity()) return;
          run(async () => {
            await request('change', { line: Number(input.dataset.line), quantity: Number(input.value) });
            location.reload();
          });
        }),
      );
      form.addEventListener('submit', (event) => {
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        const changed = [...form.querySelectorAll('[data-line][name="updates[]"]')]
          .filter((input) => input.value !== input.dataset.original)
          .reverse();
        run(async () => {
          for (const input of changed)
            await request('change', { line: Number(input.dataset.line), quantity: Number(input.value) });
          location.reload();
        });
      });
      const discount = root.querySelector('[data-cart-discount]');
      async function apply() {
        const code = discount.value.trim();
        if (!code) return;
        run(async () => {
          const cart = await request('update', { discount: code });
          const applications = [
            ...(cart.cart_level_discount_applications || []),
            ...cart.items.flatMap((item) =>
              (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application),
            ),
          ];
          const accepted =
            (cart.discount_codes || []).some(
              (item) => item.code.toLowerCase() === code.toLowerCase() && item.applicable,
            ) ||
            applications.some(
              (item) => item.type === 'discount_code' && item.title.toLowerCase() === code.toLowerCase(),
            );
          if (!accepted) throw new Error(status.dataset.invalid);
          location.reload();
        });
      }
      root.querySelector('[data-apply-discount]').addEventListener('click', apply);
      discount.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          apply();
        }
      });
    }
    const initAll = () => document.querySelectorAll('[data-cart-page]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelectorAll('[data-cart-recommendation-form]').forEach((form) => {
        let busy = false;
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (busy) return;
          busy = true;
          const button = form.querySelector('button');
          const status = form.querySelector('[role="status"]');
          button.disabled = true;
          status.textContent = '';
          try {
            const response = await fetch(root.dataset.root + 'cart/add.js', {
              method: 'POST',
              body: new FormData(form),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || status.dataset.error);
            location.reload();
          } catch (error) {
            status.textContent = error.message || status.dataset.error;
            button.disabled = false;
            busy = false;
          }
        });
      });
    }
    const initAll = () => document.querySelectorAll('[data-cart-recommendations]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-capture"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function addEmailCaptureArrow(element) {
      if (element.querySelector('.email-capture__label')) return;

      const labelText = element.textContent
        .trim()
        .replace(/(?:\s*→)+$/, '')
        .trimEnd();
      const label = document.createElement('span');
      label.className = 'email-capture__label';
      label.append(document.createTextNode(labelText));

      const arrow = document.createElement('span');
      arrow.className = 'email-capture__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      label.append(document.createTextNode(' '), arrow);
      element.replaceChildren(label);
    }

    function enhanceEmailCapture(section) {
      section.querySelectorAll('.email-form__submit, .email-capture__secondary').forEach(addEmailCaptureArrow);
    }

    function enhanceRenderedEmailCaptures() {
      document.querySelectorAll('.shopify-section.email-capture').forEach(enhanceEmailCapture);
    }

    function enhanceLoadedSection(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const section = target.matches('.email-capture') ? target : target.querySelector('.email-capture');
      if (section) enhanceEmailCapture(section);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceRenderedEmailCaptures, { once: true });
    } else {
      enhanceRenderedEmailCaptures();
    }
    document.addEventListener('shopify:section:load', enhanceLoadedSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', event => {
    if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('.ugc-videos')) return;
    document.querySelectorAll('.ugc-videos video').forEach(video => {
      if (video !== event.target) video.pause();
    });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
